import { render, staticRenderFns } from "./signature-item-page.vue?vue&type=template&id=10d8a816&scoped=true&"
import script from "./signature-item-page.vue?vue&type=script&lang=js&"
export * from "./signature-item-page.vue?vue&type=script&lang=js&"
import style0 from "./signature-item-page.vue?vue&type=style&index=0&id=10d8a816&lang=scss&scoped=true&"
import style1 from "./signature-item-page.vue?vue&type=style&index=1&id=10d8a816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d8a816",
  null
  
)

export default component.exports
import {QCard,QCardSection,QIcon,QCardActions,QBtn,QSpinnerIos,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QIcon,QCardActions,QBtn,QSpinnerIos})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
